'use strict';

var React = require('react');

var SvgReferralCodeMajor = function SvgReferralCodeMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4 3h-1v1h-2v-1.5a1.5 1.5 0 0 1 1.5-1.5h1.5v2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.707 6.255a1 1 0 1 0-1.414 1.414l1.293 1.292h-4.586a1 1 0 1 0 0 2h4.586l-1.293 1.293a1 1 0 1 0 1.414 1.414l3-3a1.001 1.001 0 0 0 0-1.415l-3-3v.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 6h2v8h-2v-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 18a1 1 0 0 1-1 1h-2v-2h1v-1h2v2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 19a1 1 0 0 1-1-1v-2h2v1h1v2h-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 3v1h2v-1.5a1.5 1.5 0 0 0-1.5-1.5h-1.5v2h1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 6h-4v8h4v-8Z"
  }));
};

exports.SvgReferralCodeMajor = SvgReferralCodeMajor;
